{
	"blockedPlace": "Le lieu {{placeName}} est bloqué",
	"blockedPlaces": "Les lieux {{placeName}} sont bloqués",
	"certificatesAboutToExpire": "Les certificats numériques des profils fiscaux {{value}} expireront dans moins de 30 jours !",
	"expiredCertificates": "Les certificats numériques des profils fiscaux {{value}} ont expiré !",
	"isApproved": "Attention ! Ce lieu est en phase de pré-approbation, il ne sera pas possible d'ouvrir des événements tant que l'approbation n'aura pas été donnée.",
	"requests_one": "Attention ! Vous avez {{valeur}} en attente de demandes de retrait du vendeur",
	"requests_other": "Attention ! Vous avez {{valeur}} en attente de demandes de retrait du vendeur"
}
